import Events from "../../Events";
import $ from "jquery";


// deps:

export default class Focus extends Events {

    static blurGrid(grid) {
        let behavior = grid.behavior;

        behavior._inFocus = false;
        behavior.trigger("blur");
    }

    static getFocusedGrid() {
        let event = {
            grid: false
        };

        system.trigger("__Focus.getFocusedGrid", event);

        return event.grid;
    }

    static blurAllGrids() {
        system.trigger("_blurAllGrids");
    }

    static focusGrid(grid) {
        let behavior = grid.behavior;
        if ( behavior._inFocus ) {
            return;
        }

        // остальные гриды должны потерять фокус
        system.trigger("_blurAllGrids", grid);

        behavior._inFocus = true;
        behavior.trigger("focus");
    }


    constructor(behavior) {
        super();

        this.behavior = behavior;

        behavior._inFocus = false;

        this.listenTo($(document), "mousedown", this.onMouseDown);
        this.listenTo(system, "_focus", this.onMouseDown);

        this.listenTo(behavior.grid, "showForm", () => {
            behavior._inFocus = false;
            behavior.trigger("blur");
        });

        // Когда открывается грид, он получает фокус,
        // а остальные должны потерять фокус
        this.listenTo(system, "_blurAllGrids", (excludeGrid) => {
            if ( behavior.grid == excludeGrid ) {
                return;
            }

            if ( behavior._inFocus ) {
                behavior._inFocus = false;
                behavior.trigger("blur");
            }
        });

        this.listenTo(system, "__Focus.getFocusedGrid",(event) => {
            if ( behavior._inFocus ) {
                event.grid = this;
            }
        });
    }

    onMouseDown(e) {
        let behavior = this.behavior;
        let $target = $(e.target);

        let isFocus = (
            behavior.grid.$el.hasChild(e.target)
                || $target.parents(".CellEditor-activeElem").length
                || $target.hasClass("CellEditor-activeElem")
        );

        //Если это инпут в тулбаре, то тоже скидываем фокус с ячеек грида
        let isToolbar = (
            behavior.grid.ui.$toolbar
                && behavior.grid.ui.$toolbar.hasChild(e.target)
        );
        let isSubGrid = behavior.grid.ui.$subGrids.hasChild(e.target);

        if (
            isToolbar
                || isSubGrid
        ) {
            isFocus = false;
        }

        if ( isFocus != behavior._inFocus ) {
            behavior._inFocus = !!isFocus;

            if ( isFocus ) {
                behavior.trigger("focus");
            } else {
                behavior.trigger("blur");
            }
        }
    }
}
